import React from 'react';
import styled from 'styled-components';
import { SectionParent, H2, H1 } from '../../StyledComponents';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Hero from '../../../assets/v2/Health/HealthHero.png';

const Section = styled(SectionParent)`
  background: #0e2c70;
  padding-top: 3rem !important;
  padding-bottom: 5rem !important;
  @media (max-width: 520px) {
    padding-top: 1rem !important;
    padding-bottom: 0rem !important;
  }
`;
const Grid = styled.div`
  display: grid;
  padding-bottom: 3rem;
  padding-top: 2rem;
  padding: 0 6rem;
  grid-template-columns: repeat(4, 1fr);
  @media (max-width: 768px) {
    grid-template-columns: repeat(4, 1fr);
    padding: 0;
  }
  @media (max-width: 700px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;
const GridItem = styled.div`
  justify-self: center;
  max-width: 80%;
  padding-top: 3rem;
  align-self: center;
  grid-column: span 2;
  @media (max-width: 768px) {
    margin-right: 0rem;
  }
  @media (max-width: 700px) {
    grid-column: span 3;
    margin-bottom: 3rem;
    display: grid;
    margin-right: 0rem;
    justify-items: center;
  }
`;
const SectionContent = styled(H2)`
  font-family: 'Nunito Sans', sans-serif;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.61;
  letter-spacing: normal;
  width: 100%;
  color: #ffffff;
  padding-top: 0.5rem;
  text-align: justify;
  img {
    margin-top: 1rem;
  }
  @media (max-width: 700px) {
    padding-left: 0;
    text-align: justify;
    width: 90%;
  }
  @media (max-width: 520px) {
    width: 120%;
    text-align: center;
  }
`;
const SectionTitle = styled(H1)`
  font-weight: bold;
  font-family: 'Nunito Sans', sans-serif;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
  @media (min-width: 1440px) {
    font-size: 28px !important;
  }
`;

const TargetImage = styled(LazyLoadImage)`
  width: 100%;
  margin-top: 2rem;
  justify-self: center;
  @media (max-width: 768px) {
    width: 90%;
    margin-top: 0;
  }
`;
const ImgWrapper = styled.div`
  display: grid;
  align-items: center;
  grid-column: span 2;
  @media (max-width: 768px) {
    grid-column: span 2;
  }
  @media (max-width: 700px) {
    grid-column: span 3;
  }
  @media (max-width: 520px) {
    padding-bottom: 2rem;
  }
`;
export default () => (
  <Section>
    <Grid>
      <GridItem>
        <SectionTitle>
          Streamline the Android telehealth Product Lifecycle
        </SectionTitle>

        <SectionContent>
          Security by design and default is mandatory for telehealth. Esper
          offers a complete toolchain for Android healthcare devices so you can
          build compliance, security, and control into every part of the product
          life cycle.
        </SectionContent>
      </GridItem>
      <ImgWrapper>
        <TargetImage src={Hero} />
      </ImgWrapper>
    </Grid>
  </Section>
);
